import { sharedDataviewHasAccessToItem } from '@libs/shared/domain/settings/dataview-item-access';
import { ItemAccess } from '@shared/dataview/core/dataview-types';
import { IUser } from '@shared/models/user.model';

export interface AccessContext {
  user?: IUser;
  hasAllTenantsAccess: boolean;
}

export function userHasAccessToItem(item: ItemAccess, { user, hasAllTenantsAccess }: AccessContext): boolean {
  return sharedDataviewHasAccessToItem(item, { role: user?.role, tenants: user?.tenants, hasAllTenantsAccess });
}

export function filterByAccess<T extends ItemAccess>(items: T[], context: AccessContext): T[] {
  return items.filter(item => userHasAccessToItem(item, context));
}
